<script setup lang="ts">
import { computed } from 'vue'

import { useResume } from '@/composables/useResume'

const { content } = useResume()

const year = computed(() => new Date().getFullYear())
</script>

<template>
  <footer>{{ content.footer }} · © {{ year }}</footer>
</template>
